import script from "./StdInventoryPicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./StdInventoryPicker.vue?vue&type=script&lang=ts&setup=true"

import "./StdInventoryPicker.vue?vue&type=style&index=0&id=be331eee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be331eee"]])

export default __exports__